import styled from 'styled-components';
import { colours, common } from 'themes/default';
import { LinkButton } from 'components/ui/Button';
import { ButtonContent } from 'components/ui/Button/Button.styles';

export const PaymentAction = styled('span')`
  background: ${({ action }) => common.paymentActions[action]?.backgroundColour};
  color: ${({ action }) => common.paymentActions[action]?.fontColour};
  padding: 4px 8px;
  border-radius: 15px;
  text-align: center;
  width: auto;
  display: inline-block;
`;

export const VoucherPaymentReferenceLink = styled(LinkButton)`
  margin: 0;
  padding: 0;
  font-size: clamp(12px, 1.1vw, 20px);
  height: clamp(12px, 1.1vw, 20px);
  font-weight: normal;
  word-break: break-all;
`;

export const PrintReceiptContainer = styled.div`
  position: absolute;
  right: -60px;
  top: calc(50% - 16px);
`;

export const PrintLinkButton = styled(LinkButton)`
  color: ${colours.Shades.BlueShade40};
  margin: 0;

  .print-message {
    display: none;
    background: ${colours.Greyscale.White};
    border: 1px solid ${colours.Greyscale.MistGrey};
    min-width: 180px;
    padding: 0 4px;
    border-radius: 4px;
    margin-right: 4px;
  }

  :hover {
    .print-message {
      display: inline;
    }
  }

  ${ButtonContent} {
    > :last-child {
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }
`;

export const PaymentReferenceContent = styled('span')`
  word-break: break-all;
`;

export const ErrorMessage = styled.p`
  color: red;
`;

export const CancelPaymentLinkModalButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: min-content min-content;
  grid-column-gap: 15px;
`;
